import { render, staticRenderFns } from "./BuyBook.vue?vue&type=template&id=093c29e2&scoped=true&"
import script from "./BuyBook.vue?vue&type=script&lang=js&"
export * from "./BuyBook.vue?vue&type=script&lang=js&"
import style0 from "./BuyBook.vue?vue&type=style&index=0&id=093c29e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093c29e2",
  null
  
)

export default component.exports